import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TitleFragment from "./TitleFragment";
import ScrollToTop from "./ScrollToTop";

function Vistor() {
    const { t } = useTranslation();
    return (
        <section>
            <TitleFragment title={t('visitor.hello')} />

            <section className="landing_cards">
                <Link onClick={ScrollToTop} to="/visitor-guest" class="flip-card">
                    <div class="flip-card-inner">
                        <div class="flip-card-front">
                            <h1 className="landing_cards_menu_title">{t('visitor.guest')}</h1>
                        </div>
                        <div class="flip-card-back">
                            <p className="landing_cards_menu_info">{t('visitor.guestInfo')}</p>
                        </div>
                    </div>
                </Link>

                <Link onClick={ScrollToTop} to="/visitor-meeting" class="flip-card">
                    <div class="flip-card-inner">
                        <div class="flip-card-front">
                            <h1 className="landing_cards_menu_title">{t('visitor.meeting')}</h1>
                        </div>
                        <div class="flip-card-back">
                            <p className="landing_cards_menu_info">{t('visitor.meetingInfo')}</p>
                        </div>
                    </div>
                </Link>

                <Link onClick={ScrollToTop} to="/visitor-interview" class="flip-card">
                    <div class="flip-card-inner">
                        <div class="flip-card-front">
                            <h1 className="landing_cards_menu_title">{t('visitor.interview')}</h1>
                        </div>
                        <div class="flip-card-back">
                            <p className="landing_cards_menu_info">{t('visitor.interviewInfo')}</p>
                        </div>
                    </div>
                </Link>
            </section>
        </section>
    )
}

export default Vistor;